import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import OptimizedImage from '@/components/OptimizedImage';
import GrainTexture from '@/components/GrainTexture';

interface PageHeroProps {
  title: string | React.ReactNode;
  subtitle?: string;
  imageName?: string;
  imageSrc?: string;
  imageWebpSrc?: string;
  cta?: string;
  ctaAction?: () => void;
  ctaLink?: string;
}

const PageHero: React.FC<PageHeroProps> = ({ 
  title, 
  subtitle, 
  imageSrc,
  imageWebpSrc,
  cta,
  ctaAction,
  ctaLink
}) => {
  return (
    <section className="relative min-h-[50vh] md:min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        {imageSrc && (
          <>
            <div className="absolute inset-0 bg-[#854C73]/60 z-10 mix-blend-multiply"></div>
            <OptimizedImage 
              src={imageSrc} 
              webpSrc={imageWebpSrc}
              alt={typeof title === 'string' ? title : 'Page hero'} 
              className="w-full h-full object-cover transform scale-105" 
              width={1920}
              height={1080}
            />
          </>
        )}
        <GrainTexture opacity={0.2} />
      </div>
      <div className="container mx-auto relative z-20 text-center text-white px-4 sm:px-6 animate-fade-up">
        <Button variant="ghost" asChild className="mb-6 md:mb-8 hover:bg-white/20 text-white hover:text-white border border-white/30 mx-auto flex w-fit px-4 sm:px-6 py-2 h-auto text-sm sm:text-base">
          <Link to="/">
            <ArrowRight className="mr-2 w-4 h-4 rotate-180" /> Terug naar home
          </Link>
        </Button>
        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-7xl mb-4 md:mb-6 leading-tight drop-shadow-lg px-2">{title}</h1>
        {subtitle && (
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed opacity-95 font-light drop-shadow-md px-2">
            {subtitle}
          </p>
        )}
        {cta && (
          <div className="mt-8 md:mt-10">
            {ctaLink ? (
              <Button variant="white" asChild className="py-3 md:py-4 px-6 sm:px-8 md:px-10 text-sm sm:text-base md:text-lg shadow-xl text-[#854C73] w-full sm:w-auto">
                <Link to={ctaLink}>{cta}</Link>
              </Button>
            ) : (
              <Button variant="white" onClick={ctaAction || (() => window.location.href = '/contact')} className="py-3 md:py-4 px-6 sm:px-8 md:px-10 text-sm sm:text-base md:text-lg shadow-xl text-[#854C73] w-full sm:w-auto">
                {cta}
              </Button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;

